import { t } from '@lingui/core/macro'
import { KeyboardBackspace as BackIcon } from '@mui/icons-material'
import LockIcon from 'images/lock.svg'
import { Typography } from '@mui/material'
import { motion } from 'framer-motion'
import { useHistory } from 'react-router-dom'
import { colors } from '@global/constants/colors'
import { Tooltip as CustomTooltip } from '@components/tooltip/tooltip'
import type { List } from '../types'

interface TitleBlockProps {
  list: List
  isApproverMode: boolean
  isOwner: boolean
  isLocked: boolean
}

export const TitleBlock = ({ list, isApproverMode, isOwner, isLocked }: TitleBlockProps) => {
  const history = useHistory()

  const title = list.name ?? t`New Pick List`

  const lockTooltipMessage = !isApproverMode
    ? t`This pick list is locked while pending suggestions are under review. Once all suggestions are resolved, new comments and suggestions can be added.`
    : isOwner
      ? t`This pick list is locked while pending suggestions are under review. Suggesters cannot make new comments or suggestions, and no one can add, remove, or edit columns or rows. To unlock, resolve all suggestions and save the pick list.`
      : t`This pick list is locked while pending suggestions are under review by another approver. Suggesters cannot make new comments or suggestions, and no one can add, remove, or edit columns or rows.`

  return (
    <div style={{ flexShrink: 1 }}>
      <div
        style={{
          backgroundColor: colors.gray.light,
          minHeight: 120,
          padding: 16,
          display: 'flex',
          justifyContent: 'center',
          wordBreak: 'break-word',
          flexDirection: 'column',
          hyphens: 'auto',
          flexShrink: 1,
          width: 250,
        }}
      >
        <div className="flex justify-between items-center">
          <Typography variant="overline" display="block" gutterBottom>
            {t`Edit pick list`}
          </Typography>
          {(isLocked || isOwner) && (
            <CustomTooltip
              placement="bottom"
              title={lockTooltipMessage}
              className="text-center"
              mode="light"
            >
              <LockIcon />
            </CustomTooltip>
          )}
        </div>
        <Typography variant="h4" gutterBottom>
          {title}
        </Typography>
      </div>
      <motion.div
        onClick={() => {
          history.goBack()
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.2 } }}
        exit={{ opacity: 0, height: 0, transition: { duration: 0.2 } }}
        key="back"
        style={{
          backgroundColor: colors.gray.blue,
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          height: 40,
        }}
      >
        <BackIcon style={{ marginRight: 12, marginLeft: 12 }} />
        {t`Back`}
      </motion.div>
    </div>
  )
}
